import React, { type Node, useState } from 'react';
import { Button, ButtonToolbar } from 'angieslist-react-components';
import { formatPhoneNumber } from 'angieslist-app-platform/lib/common/utils/stringUtils';
import { Track, urlCatalog } from 'angieslist-app-platform';
import { Link } from 'react-router';
import { isUndefined } from 'lodash';
import CardModal from '../Dashboard/Card/CardModal';
import CircularIcon from '../Dashboard/CircularIcon';

type Props = {
  ctaText: string,
  buttonProps?: any,
  returnLinkOnly?: boolean,
  name: string,
  phoneNumber: string
};

const styles = {
  modalBody: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
};

const DealsModal = ({
  ctaText, buttonProps, returnLinkOnly, name, phoneNumber,
}: Props): Node => {
  const [showModal, setModalShow] = useState(false);
  const unformattedPhoneNumber = phoneNumber === 'no-phone' || isUndefined(phoneNumber) ?
    urlCatalog.global.businessCenterPhoneText() : phoneNumber;
  const handleShow = () => setModalShow(true);
  const handleClose = () => setModalShow(false);
  return (
    <div>
      <CardModal
        showModal={showModal}
        handleClose={handleClose}
        iconClassName="icon-offer-dollars"
        headerText="What are Deals?"
        modalBody={
          <div>
            <p>
            When you participate in our Deals solution, you can create exclusive
            deals to highlight your business as consumers narrow their search
            for a service.
            </p>
            <p>
            To find out if you&apos;re eligible to participate give us a call at:
            </p>
            <p style={styles.modalBody}>
              <Track>
                <a
                  href={urlCatalog.global.businessCenterPhone()}
                  className="btn btn-link phone-text"
                  id="dashboard--deals-modal--phone"
                >
                  <span style={{ marginRight: '.5em' }}>
                    <CircularIcon iconClassName="icon-phone" />
                  </span>
                  <strong>{formatPhoneNumber(unformattedPhoneNumber)}</strong>
                </a>
              </Track>
              <div className="name-text">{name || 'Angi Business Center'}</div>
            </p>
          </div>
      }
      />
      <span>
        <Choose>
          <When condition={returnLinkOnly}>
            <Track>
              <Link
                id="card-cta-button-deals-modal-link-only"
                className="text-info"
                onClick={handleShow}
                {...buttonProps}
              >
                {ctaText}
              </Link>
            </Track>
          </When>
          <Otherwise>
            <ButtonToolbar className="cta-toolbar">
              <Track>
                <Button
                  id="card-cta-button-deals-modal"
                  bsStyle="link"
                  bsSize="small"
                  className="cta-button text-info"
                  ghost
                  onClick={handleShow}
                  {...buttonProps}
                >
                  {ctaText}
                </Button>
              </Track>
            </ButtonToolbar>
          </Otherwise>
        </Choose>
      </span>
    </div>
  );
};

export default(DealsModal);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/DashboardV2/DealsModal.js